import { UnknownError } from '@cian/peperrors/shared';

import { TDeleteOfferFromFavoritesResponse } from '../../../../repositories/favorites/v1/delete-offer-from-favorites';

export const assertUnknownError = (response: TDeleteOfferFromFavoritesResponse): void => {
  if (response.statusCode !== 400) {
    return;
  }

  const { message, errors } = response.response;

  throw new UnknownError({
    domain: 'src/shared/services/favorite/deleteFavorite/deleteFavoriteRequest.ts',
    message: message || '',
    details: {
      errors,
    },
  });
};
